export default {//泰卢固语
  line: "లైన్",
  language: "భాష",
  common: [
"ఆన్‌లైన్ సేవలు",
"సస్పెన్షన్‌ను రద్దు చేయి",
"కొనుగోలు చేయడానికి 10,000 ₽ ఖర్చు చేయాలా వద్దా!"
  ],
  informationHub: "SGM.s అధికారిక హబ్",
  charitables:[//慈善
  	  "SGM.s యొక్క అధికారిక సమాచార కేంద్రానికి స్వాగతం! 🌟 పారదర్శకమైన, అధికారిక సమాచారం కోసం మీ వేదిక. ఇక్కడ, మీరు మా అధికారిక ధృవీకరణ పత్రాలను తనిఖీ చేయవచ్చు 📜, వివరణాత్మక సమాచారం కోసం www.sgm.top ని సందర్శించవచ్చు 🌐 మరియు తాజా అప్‌డేట్‌ల కోసం మా Telegram ఛానెల్‌ని అనుసరించవచ్చు! 📲 అదనంగా, Yahoo, అసోసియేటెడ్ ప్రెస్, Google వంటి అంతర్జాతీయ మీడియా నుండి SGM.s గురించిన సానుకూల సమీక్షలను కూడా మీరు చూడవచ్చు! 📰 ఇవన్నీ SGM బ్రాండ్ మరియు దాని భవిష్యత్తు అభివృద్ధిపై మీ విశ్వాసాన్ని గణనీయంగా పెంచుతాయి, మీరు భాగస్వామ్య మొబిలిటీ వ్యాపారంలో విజయం సాధించడానికి మరియు నిరంతరం గణనీయమైన అదనపు ఆదాయాన్ని పొందడానికి సహాయపడతాయి! 💰🚀"
  	  ],
  upload: [
"అప్‌లోడ్ అవుతోంది...",
"తప్పు ఫార్మాట్",
"విజయవంతంగా అప్‌లోడ్ చేయబడింది",
"అప్‌లోడ్ విఫలమైంది"
  ],
  details:[
  	  "టాస్క్ యూనిట్ ధర",
  	  "ఆర్డర్ సంఖ్య",
  	  "రోజువారీ ఆదాయం",
  	  "స్థాయి",
  	  "రోజువారీ లాభం",
  	  "డిపాజిట్",
  	  "డిపాజిట్ రిటర్న్ తేదీ",
  	  "మిగిలిన రోజులు",
  	  "నా SGM.s స్థాయి"
  ],
  vanPull: [
"ఇక డేటా లేదు",
"డేటా లేదు"
  ],
  login: {
    title:'యూజర్ నేమ్ మరియు పాస్‌వర్డ్‌తో లాగిన్ అవ్వండి',
    title_txt:'మీ రిజిస్టర్డ్ మొబైల్ ఫోన్ నంబర్ ఉపయోగించి లాగిన్ అవ్వండి',
    text: [
"యూజర్ నేమ్/పాస్‌వర్డ్ గుర్తుంచుకోండి",
"లాగింగ్...",
"ఇప్పుడే లాగిన్ అవ్వండి"
    ],
    placeholder: [
"దయచేసి ఫోన్ నంబర్ నమోదు చేయండి",
"దయచేసి లాగిన్ పాస్‌వర్డ్ నమోదు చేయండి"
    ],
    i18n: [
"{title} ఖాతా లేదా? {a} {line}",
"నమోదు చేయి"
    ]
  },
  register: {
    text: [
"రిజిస్టర్ చేసుకోవడానికి స్వాగతం",
"SMS కోడ్ పంపుతోంది...",
"SMS కోడ్ పొందండి",
"రిజిస్టర్ అవుతోంది...",
"ఇప్పుడే రిజిస్టర్ చేసుకోండి",
"ఇప్పటికే ఖాతా ఉందా? ఇప్పుడే లాగిన్ అవ్వండి",
"మొబైల్ ఫోన్ నంబర్ రిజిస్ట్రేషన్",
"ఇమెయిల్ రిజిస్ట్రేషన్",
"లాగిన్‌కి తిరిగి వెళ్ళు",
"దయచేసి రిజిస్టర్ చేయని ఫోన్ నంబర్ మరియు ఇమెయిల్ చిరునామాను ఉపయోగించండి"
    ],
    placeholder: [
"దయచేసి మీ ఫోన్ నంబర్‌ను నమోదు చేయండి",
"దయచేసి SMS ధృవీకరణ కోడ్‌ను నమోదు చేయండి",
"దయచేసి లాగిన్ పాస్‌వర్డ్‌ను నమోదు చేయండి",
"దయచేసి మీ పాస్‌వర్డ్‌ను నిర్ధారించండి",
"దయచేసి ఆహ్వాన కోడ్‌ను నమోదు చేయండి",
"రెండు పాస్‌వర్డ్‌లు భిన్నంగా ఉన్నాయి",
"దయచేసి ధృవీకరణ కోడ్‌ను నమోదు చేయండి",
"దయచేసి ఇమెయిల్ నంబర్‌ను నమోదు చేయండి",
"0 తో ప్రారంభించలేము"
    ],
    i18n: [
"ఖాతా ఉందా? {a} {line}",
"లాగిన్"
    ]
  },
  home: {
    lucky: "ఈ కార్యక్రమం ఇంకా ప్రారంభం కాలేదు.",
    map: "స్థానం",
    qywh: "కార్పొరేట్ సంస్కృతి",
    broadcast: "SGM.s ఆన్‌లైన్ బైక్-షేరింగ్ ప్రోగ్రామ్‌లో చేరమని స్నేహితుడిని ఆహ్వానించినందుకు, {vipname}కి పదోన్నతి పొందినందుకు మరియు {grade} షేరింగ్ రివార్డ్‌లను అందుకున్నందుకు {member}కి అభినందనలు..",
    menu: [
"VIP ప్రాంతం",
"వీడియో ట్యుటోరియల్",
"ప్రమోషన్ రివార్డ్‌లు"
    ],
    taskHall: {
      title: [
"టాస్క్ హాల్",
"బిజినెస్ హాల్",
"లాభాలు సంపాదించడానికి పనులు పూర్తి చేయండి"
      ]
    },
    title:['టాస్క్','వార్తలు','మరిన్ని','అన్‌లాక్','దయచేసి అన్‌లాక్ చేసి ఉపయోగించడం కొనసాగించండి~','చెక్ అవుట్','అభినందనలు!అప్‌గ్రేడ్ విజయవంతమైంది','సంతోషాలు~ రెండు డ్రాప్ కార్డ్‌లను పొందారు'],
    memberList: {
      title: "సభ్యత్వ జాబితా",
      data: [
        "{member},ఈరోజు {num} ఆర్డర్ పనులను పూర్తి చేయి!"
      ]
    },
    businessList: {
      title: "వ్యాపారి జాబితా",
      data: [
        "{member}",
        "ఈరోజే {num} సింగిల్ టాస్క్‌ను విడుదల చేయి"
      ]
    },
    noticeTitle: ["గమనించండి","మునుపటి","తదుపరి"],
    tabBar: ["హోమ్","డెలివరీ","టి", "మ్యాప్", "నా"],
    msg: "టాస్క్ ఓపెన్ కాలేదు",
    video: "వీడియో ట్యుటోరియల్ లేదు",
	  message: "మీకు కొత్త వార్తలు ఉన్నాయి",
	  bonus:[
'<p>"సైక్లింగ్ కోడ్" నగదు బహుమతి (1-200000 రూ) పొందడానికి కోడ్‌ను నమోదు చేయండి</p><p>1. "సైక్లింగ్ కోడ్" కంపెనీ కార్యకలాపాల ద్వారా పొందబడుతుంది!</p><p>2. వర్కింగ్ గ్రూప్ ఎప్పటికప్పుడు పాస్‌వర్డ్‌లను జారీ చేస్తుంది! మీరు ప్రతిరోజూ వర్కింగ్ గ్రూప్ సమాచారానికి శ్రద్ధ వహించవచ్చు!</p><p>సైకిళ్లను అమర్చండి, షేరింగ్ ఎకానమీ జీవితాన్ని ఆస్వాదించండి మరియు కోడ్ నగదు బహుమతులను సులభంగా స్వీకరించండి!</p><p>వివరాల కోసం, దయచేసి "రిక్రూట్‌మెంట్ మేనేజర్"ని సంప్రదించండి</p>',
'కంపెనీ కార్యకలాపాల ద్వారా పాస్‌వర్డ్ పొందబడుతుంది!',
'ఎరుపు ఎన్వలప్ కోడ్‌ను నమోదు చేయండి',
'నగదు పొందండి',
'రైడ్ క్యాష్ {amount}TJS గెలుచుకున్నందుకు అభినందనలు',
'రైడ్ క్యాష్'
	],
    helpCenter: {
      title: "Help Center",
      empty: "No help articles"
    }
  },
  vip: {
    title:[
"VIP స్థాయి",
"టాస్క్‌లను క్లెయిమ్ చేయడానికి ఇప్పుడే సభ్యత్వంలో చేరండి",
"అభివృద్ధిలో ఉంది"
    ],
    user: {
      title: [
"మీ గుర్తింపు",
"సందర్శకులు"
      ],
      label: "రోజువారీ పనులు",
      value: [
"అమలు తేదీ",
"ఒక సంవత్సరం",
"దయచేసి ముందుగా లాగిన్ అవ్వండి",
"ఇంటర్న్‌షిప్ చెల్లుబాటు వ్యవధి",
"డిపాజిట్ రిటర్న్ కౌంట్‌డౌన్",
"లెవల్ VIP చెల్లుబాటు కౌంట్‌డౌన్"
      ],
    },
    list: {
      label: "రోజువారీ క్రమం:{number}",
      button: "ఇప్పుడే చేరండి",
      text: [
"రోజువారీ లాభం",
"నెలవారీ ఆదాయం",
"నియామక బహుమతి: అందరికీ",
"ఉచితం",
"ఆర్డర్ ప్రకారం",
"రేటింగ్ ఆదాయం",
"ప్రభావవంతమైన రాబడి",
"గడువు తేదీ",
"సంవత్సరం",
"రోజు",
"చెల్లుబాటు వ్యవధి"
      ],
    },
    dialog: [
"మీరు {name} అవ్వడానికి {currency} {amount} ఖర్చు చేస్తారా?",
"మీరు ప్రస్తుతం {currname} మరియు {name} కాలేరు",
"మీరు {name}ని పునరుద్ధరించడానికి {currency} {amount} ఖర్చు చేస్తారా?",
    ],
    index: ["రద్దు చేయి", "నిర్ధారించు"],
    desc: [
'{level} ప్రయోజనాలు',
'ప్రాథమిక ఆదాయం',
'సమయం',
'డెలివరీ సంఖ్య',
'ఆదాయం',
'రోజువారీ',
'నెలవారీ',
'వార్షిక',
'రిక్యూట్‌మెంట్ ఆదాయం',//8
'సబార్డినేట్ స్థాయి',
'రిక్రూట్‌మెంట్ కమిషన్ నిష్పత్తి',
'రిక్రూట్‌మెంట్ బోనస్',
'లెవల్ 1 సబార్డినేట్',
"లెవల్ 2 సబార్డినేట్",
"లెవల్ 3 సబార్డినేట్",
'సింగిల్ డే డెలివరీ రిబేట్',
'సబార్డినేట్ లెవల్',
'సబార్డినేట్ డెలివరీ రిబేట్ రేషియో',//17
'డెలివరీ రిబేట్ మొత్తం',
'లెవల్ 1 సబార్డినేట్',
'లెవల్ 2 సబార్డినేట్',
'లెవల్ 3 సబార్డినేట్',
'3 రోజులు',
'డెలివరీ యూనిట్ ధర',
 'ప్రొబేషన్ వ్యవధి వివరాలు',//24
'ఇంటర్న్‌షిప్: కొనుగోలు అవసరం లేదు, రోజుకు 6 ప్లేస్‌మెంట్‌లు, ప్లేస్‌మెంట్‌కు 11 రూపాయల కమిషన్, రోజుకు 66 రూపాయలు. 3 రోజుల ఉచిత ట్రయల్',
'టాస్క్ కమిషన్ ఉదాహరణ:',
'<p>రోజుకు 10,000 TJS విలువైన రైడ్ ఆర్డర్‌లను పూర్తి చేసే లెవల్ 1 అనుబంధ సంస్థలు TJS 300 కమిషన్‌ను సంపాదిస్తాయి.</p><p>రోజుకు 10,000 TJS విలువైన రైడ్ ఆర్డర్‌లను పూర్తి చేసే లెవల్ 2 అనుబంధ సంస్థలు TJS 200 కమిషన్‌ను సంపాదిస్తాయి.</p><p>రోజుకు 10,000 TJS విలువైన రైడ్ ఆర్డర్‌లను పూర్తి చేసే లెవల్ 3 అనుబంధ సంస్థలు TJS 100 కమిషన్‌ను సంపాదిస్తాయి. </p><p>రోజుకు 10,000 TJS విలువైన రైడ్ ఆర్డర్‌లను పూర్తి చేసే లెవల్ 3 అనుబంధ సంస్థలు TJS 100 కమిషన్‌ను సంపాదిస్తాయి. </p>',
'రిఫరల్ బోనస్ వివరణ:',
'<p>(స్థాయి 1 సబార్డినేట్) మీరు A ని నేరుగా చేరమని ఆహ్వానిస్తారు, A మీ స్థాయి 1 సబార్డినేట్.</p><p>(స్థాయి 2 సబార్డినేట్) A B ని చేరమని ఆహ్వానిస్తుంది, B మీ స్థాయి 2 సబార్డినేట్.</p><p>(స్థాయి 3 సబార్డినేట్) B C ని చేరమని ఆహ్వానిస్తుంది, C మీ స్థాయి 3 సబార్డినేట్.</p><p>గమనిక: రిఫెరల్ బోనస్‌ను వ్యక్తి యొక్క ప్రస్తుత స్థాయిలో అత్యధిక బోనస్‌కు మాత్రమే క్లెయిమ్ చేయవచ్చు.</p>',
    ]
  },
  charitable:[
'గ్రీన్ ఫిలాంత్రోపీ ఇనిషియేటివ్',
'SGM.s దాతృత్వం మరియు ప్రజా సంక్షేమాన్ని కార్పొరేట్ లక్ష్యంగా భావిస్తుంది. మేము తక్కువ ఆదాయ సంఘాలు, వికలాంగులు మరియు పాఠశాలలకు క్రమం తప్పకుండా సామాగ్రి మరియు నిధులను విరాళంగా ఇస్తాము మరియు గ్రీన్ మొబిలిటీ మరియు పర్యావరణ ప్రాజెక్టులపై ప్రభుత్వేతర సంస్థలతో సహకరిస్తాము.',
'మేము మోహరించే ప్రతి షేర్డ్ బైక్ ఒక ఛారిటబుల్ విరాళాన్ని సూచిస్తుంది, నగరాలు ఉద్గారాలను తగ్గించడంలో సహాయపడుతుంది మరియు వెచ్చదనాన్ని కూడా వ్యాపింపజేస్తుంది.',
'మేము "సైక్లింగ్, ఛారిటీ మరియు గెలుపు-గెలుపు" అనే స్ఫూర్తిని నిలబెట్టుకుంటాము మరియు మా చక్రాలతో ఆశను వెలిగిస్తాము. SGMలో చేరమని, హరిత భవిష్యత్తు కోసం ప్రయాణించమని మరియు ప్రేమను వ్యాప్తి చేయమని మేము మిమ్మల్ని హృదయపూర్వకంగా ఆహ్వానిస్తున్నాము.',
'కమ్యూనిటీ ఛారిటబుల్ ఇనిషియేటివ్‌లలో చురుకుగా పాల్గొనమని మరియు కలిసి, నగరంలోని ప్రతి మూలలో ప్రేమ మరియు ఆకుపచ్చ వృద్ధి చెందనివ్వమని మేము మిమ్మల్ని ప్రోత్సహిస్తున్నాము.'
  ],
  lucky: {
  	default:[
"లక్కీ పెడల్",
"మిగిలిన డ్రాల సంఖ్య:",
"రాఫెల్ రికార్డ్",
"లాటరీ నియమాలు",
"<p>కంపెనీ కార్యకలాపాల్లో పాల్గొని లక్కీ డ్రా అవకాశాలను పొందండి!</p>",
"విజేత వినియోగదారు రికార్డ్",
['అభినందనలు:{member}','బహుమతులు పొందండి {profit}'],
"అభినందనలు,బహుమతులు పొందండి",
"మూసివేయి",
"మీ డ్రా సమయాలు అయిపోయాయి",
"చెల్లుబాటు అయ్యే వరకు"
  	],
    scattered:[
'డ్రా సంఖ్య',
'రైడ్',
'<p>1.కంపెనీ కార్యకలాపాల ద్వారా డ్రాల సంఖ్యను పొందవచ్చు!</p><p>2.ప్రతి డ్రాకు 1 డ్రా ఖర్చవుతుంది!</p><p>3.భౌతిక బహుమతిని గెలుచుకున్న తర్వాత, దయచేసి మీ సమాచారాన్ని నమోదు చేసుకోవడానికి మరియు దానిని స్వీకరించడానికి రిక్రూట్‌మెంట్ మేనేజర్‌ను సంప్రదించండి!</p>',
'రిమైండర్',
'ముఖ్యమైన జ్ఞాపికలు',
'డ్రా అర్హత',
'కంపెనీ కార్యకలాపాల ద్వారా డ్రా అవకాశాలను పొందండి',
'డ్రా నియమాలు',
'ప్రతి ప్రయత్నానికి 1 డ్రా వినియోగించబడుతుంది',
'బహుమతి విమోచన',
'భౌతిక బహుమతుల కోసం నియామక నిర్వాహకుడిని సంప్రదించండి'
    ],
	prizeList:[
		'లక్కీ పెడల్ ప్రైజ్ పూల్',
		'TJS52 క్యాష్',
		'తక్షణ ఉపసంహరణ',
		'TJS88 క్యాష్',
		'TJS205 క్యాష్',
		'TJS19,889 క్యాష్',
		'TJS236,666 క్యాష్',
		'ఆండ్రాయిడ్ ఫోన్',
		'TJS8,000 విలువైనది',
		'అప్‌గ్రేడ్ వోచర్',
		'TJS600 విలువ',
		'డబుల్ ఆర్డర్‌లు',
		'రోజువారీ',
		'SGM.s కంపెనీ ఎక్స్‌క్లూజివ్ పవర్ బ్యాంక్',
		'TJS1,000 విలువైనది',
		'మెకానికల్ బైక్',
		'TJS3,000 విలువైనది',
		'ఈ-మోపెడ్',
		'TJS80,000 విలువైనది',
		'ఐఫోన్ 17',
		'TJS160,000 విలువైనది'
	],
  },
  moments:[
	  'రోజువారీ నవీకరణలు',
	  'బైక్ విస్తరణ ఆదాయాలు, దాతృత్వ కార్యకలాపాలు మరియు అద్భుతమైన క్షణాలను పంచుకోవడానికి SGM ఉద్యోగులకు అధికారిక వేదిక. నగదు బహుమతి డ్రాలలో (1-200,000 రూ.) పాల్గొనడానికి వరుసగా 3 రోజులు ప్రతిరోజూ నవీకరించండి. ప్రేమను వ్యాప్తి చేయడంలో మరియు ప్రతి రైడ్‌ను మరింత విలువైనదిగా చేయడంలో సహచరులతో చేరండి.!'
  ],
  userLc:{
  	default:[
"సైక్లింగ్ సంపద",
"రికార్డులు",
"మొత్తం",
"నిల్వ వ్యవధి",
"డిపాజిట్ మొత్తం",
"దయచేసి డిపాజిట్ మొత్తాన్ని నమోదు చేయండి",
"ఆదాయం",
"సమర్పించు",//7
"దయచేసి ముందుగా ఉత్పత్తిని ఎంచుకోండి",
"దయచేసి సమాచారాన్ని ఎంచుకోండి",
"లాభం",
"రోజు",
"డేటా లేదు",
"కొనుగోలు సమయం",
"రాష్ట్రం",
"ముగింపు సమయం",
"బ్యాలెన్స్",
"నేటి ఆదాయాలు",
"ఒక-క్లిక్ కొనుగోలు"//18
  	],
    tabs: [
"ఉత్పత్తి జాబితా",
"పొదుపు రికార్డు"
     ],
    tips:'<p>VOISP "వెల్త్ ఎన్‌హాన్స్" అనేది అన్ని M-స్థాయి ఉద్యోగులకు వారి ఆదాయాన్ని పెంచుకోవడానికి మరిన్ని మార్గాలను అందించడానికి కంపెనీ యొక్క మార్గం. పెట్టుబడి ప్రాజెక్టులు PAGE, బ్యాంకులు, ఆస్తి నిర్వహణ కంపెనీలు మొదలైన వాటి ద్వారా సంయుక్తంగా ప్రారంభించబడిన ఆర్థిక పెట్టుబడి ప్రాజెక్టులు!</p><p>స్వల్పకాలిక పెట్టుబడి: స్థిరమైన ఆదాయం, సౌకర్యవంతమైన చక్ర ఎంపిక! స్వల్పకాలిక నిష్క్రియ నిధులు పెట్టుబడి ద్వారా అదనపు ఆదాయాన్ని తీసుకురాగలవు! దీర్ఘకాలిక పెట్టుబడి: అధిక రాబడి, మంచి సాధారణ పెట్టుబడి పొదుపులను పెంపొందించుకోండి, అధిక రాబడిని కలిగి ఉండండి మరియు సంచితం ద్వారా మీ కలలను సాకారం చేసుకోండి.!</p>'
  },
  newlist: {
    text: [
"రికార్డులు లేవు",
"ఆశించిన ఆదాయం",
"ఫలితాలు",
"కొనుగోలు సమయం",
"స్థితి",
"సమయం ముగిసింది"
    ],
    placeholder: [
"ఇక డేటా లేదు",
"డేటా లేదు"
    ],
    i18n: [
     "కొనుగోలు చరిత్ర",
    ],
	title:[
		"Cycling Wealth గ్రీన్ సేవింగ్స్ ప్లాన్ — SGM.s సంస్థ తన శాశ్వత ఉద్యోగుల కోసం ప్రత్యేకంగా రూపొందించిన ప్రత్యేక ప్రయోజనం!",
		"RBI వంటి విశ్వసనీయ ఆర్థిక సంస్థల ద్వారా నియంత్రించబడిన మరియు అనుమతించబడిన ఈ ప్లాన్‌లో మీ నిధులు 100% భద్రంగా ఉంటాయి. ప్రముఖ బ్యాంకులతో కలిసి, SGM.s అనేక రకాల సేవింగ్స్ ఉత్పత్తులను అందిస్తోంది, ఇవి వేర్వేరు కాలపరిమితులు మరియు లాభాలతో మీ ఆర్థిక లక్ష్యాలకు అనుగుణంగా ఉంటాయి.",
		"మేము మీరు సైకిల్ వినియోగంలో చురుకుగా పాల్గొనాలని, తక్కువ కార్బన్ ప్రయాణాన్ని ప్రోత్సహించాలని మాత్రమే కాకుండా, మీ భవిష్యత్తు కోసం ఆర్థిక ప్రణాళికను తెలివిగా రూపొందించాలని ఆశిస్తున్నాము. SGM.s మీతో కలిసి, గ్రీన్ వెల్త్ యొక్క కొత్త అధ్యాయాన్ని ప్రారంభించడానికి సిద్ధంగా ఉంది!"
	]
  },
  product: {
    default: [
"ప్రమోషన్ ఖాతా బ్యాలెన్స్",
"ప్రారంభ పొదుపు మొత్తం",
"గరిష్ట పొదుపు మొత్తం",
"చక్రం",
"రోజువారీ వడ్డీ రేటు",
"గరిష్ట",
"ప్రాజెక్ట్ నియమాలు",
"ప్రాజెక్ట్ మొత్తం",
"చెల్లింపు పద్ధతి",
"ప్రారంభ పొదుపు మొత్తం",
"రోజువారీ లాభం",
"విడుదల చక్రం",
"అంచనా వేసిన ఆదాయం"
    ],
    investRange: "పెట్టుబడి మొత్తం పరిధి",
    placeholder: [
"మెచ్యూరిటీ తర్వాత అసలు మరియు ఆదాయాన్ని తిరిగి ఇవ్వండి (సెలవు దినాల్లో సాధారణం)",
", 24 గంటల్లోపు ఆటోమేటిక్ సెటిల్మెంట్",
"{str} = మొత్తం ఆదాయం {income} {currency} + అసలు {money} {currency} = మొత్తం అసలు మరియు వడ్డీ {total} {currency}",
"భద్రతా పాస్‌వర్డ్"
    ]
  },
  user: {
    vipl:"భాగస్వామి స్థాయి",
    hello:"పునఃస్వాగతం",
    default: [
"నా ఉన్నతాధికారి",
"ఖాతా",
"ఆహ్వాన కోడ్",
"లాగిన్ నుండి నిష్క్రమించు",
"బ్యాలెన్స్",
"బంగారం",
"నా వాలెట్",
"ముద్ర",
"పరిమితి",
"మంచిది",
"అద్భుతం",
"'రీడింగ్ అసిస్టెంట్'ని సక్రియం చేయండి",
"నియామక నిర్వాహకుడిని సంప్రదించండి",
"బ్యాంక్ రుసుము"
    ],
    myEarnings: {
            grid: ["బ్యాలెన్స్","నిన్నటి ఆదాయాలు","నేటి ఆదాయాలు","ఈ వారం ఆదాయాలు","ఈ నెల ఆదాయాలు","గత నెల ఆదాయాలు","మొత్తం ఆదాయం","నేటి పనిని పూర్తి చేయండి(PCE)","నేటి మిగిలిన పనులు(PCE)","నేటి కమిషన్","డెలివరీ రిబేట్","రిఫెరల్ రిబేట్"]
        },
    grid: [
"బ్యాలెన్స్",
"నిన్నటి ఆదాయాలు",
"నేటి ఆదాయాలు",
"ఈ వారం ఆదాయాలు",
"ఈ నెల ఆదాయాలు",
"గత నెల ఆదాయాలు",
"మొత్తం ఆదాయం",
"ఈ రోజు పనిని పూర్తి చేయండి (PCE)",
"నేటి మిగిలిన పనులు (PCE)",
"నేటి కమిషన్",
"నేటి రాయితీ"
    ],
    menu: [
"టాస్క్ రికార్డులు",
"ఆడిట్ టాస్క్",
"విడుదల నిర్వహణ",
"వ్యక్తిగత సమాచారం",//3
"ఖాతా బైండింగ్",
"రోజువారీ ప్రకటన",
"అకౌంటింగ్ రికార్డులు",//6
"షేర్డ్ ఇన్విటేషన్",
"టీమ్ రిపోర్ట్స్",//8
"హెల్ప్ మాన్యువల్",//9
"క్రెడిట్ స్కోర్",//10
"APP డౌన్‌లోడ్",//11
"లక్కీ పెడల్",//12
"సైక్లింగ్ వెల్త్",
"రీడింగ్ అసిస్టెంట్",
"కార్పొరేట్ కల్చర్",
"వీడియో ఇన్స్ట్రక్షన్",
"అద్భుతమైన బృందం",
"సైక్లింగ్ వెల్త్",
"SGM.sని అనుసరించండి",
"గ్రోత్ రివార్డ్స్",
"సైక్లింగ్ కోడ్",
"డీడ్స్ పెడల్",
"SGM ధృవపత్రం"
    ],
	positions:[
"నా స్థానం",
"ప్రస్తుత స్థానం",
"తదుపరి స్థానం",
"నేరుగా అనుబంధించబడిన M-స్థాయి సభ్యుడు",
"స్థాయి 3 జట్టు M సభ్యుడు",
"స్థాయి 3 బృందం ({post} సంఖ్య)",
"మీ స్థానాన్ని ముందుకు తీసుకెళ్లడానికి నియామక నిర్వాహకుడిని సంప్రదించడానికి అన్ని అర్హతలను పూర్తి చేయండి!",
"స్థానం వివరణ",
"స్థానం దరఖాస్తు",
"స్థానం సమాచారం"
	],
	office:[
"నా ఉద్యోగ సమాచారం",
"ఉద్యోగ ప్రమోషన్ వివరాలు",
"SGM.s ఉద్యోగ వివరణ",
"కార్పొరేట్ స్థానం",
"ఉద్యోగ ప్రమోషన్",
"మీ దరఖాస్తును సమర్పించండి",
"ప్రమోషన్ పురోగతి",
"కనీసం ",
"షరతులు నెరవేరలేదు",//8
"మూడు-స్థాయి బృందంలోని సభ్యులు (1/2/3) ({name}) గా మారాలి",
"జట్టులో ",
" కంటే ఎక్కువ మంది సభ్యులు ఉండాలి",
"పొందబడింది"//12
	],
	current:[
"ప్రస్తుత పదవులు",
"VIP మొత్తం సభ్యులు"
	],
	subordinate:[
"1-లెవల్",
"2-లెవల్",
"3-లెవల్",
"సభ్యుల జాబితా",
"మొత్తం వ్యక్తులు",
"మొత్తం ఆదాయం",
"ఉపసంహరణ మొత్తం",
"జట్టు ఆదాయం",
"సభ్యుల జాబితా",
"యూజర్",
"లెవల్",
"చేరిన సమయం",
"ట్రయల్ వ్యవధి"
	],
	follow:[
"SGM.s అధికారిక ఛానెల్",
"తాజా SGM.s సమాచారం గురించి మరింత తెలుసుకోవడానికి ఛానెల్‌ని అనుసరించండి!"
	]
  },
  userInfo: {
    default: [
"వ్యక్తిగత సమాచారం",
"హెడ్ పోర్ట్రెయిట్",
"మొబైల్ నంబర్",
"బ్యాంక్ ఖాతాను జోడించండి",
"అలిపే",
"అసలు పేరు",
"లాగిన్ పాస్‌వర్డ్",
"ఫండ్ పాస్‌వర్డ్",
"సెట్టింగ్‌లను క్లిక్ చేయండి",
"హెడ్ పోర్ట్రెయిట్‌ను మార్చండి",
"లాగిన్ పాస్‌వర్డ్‌ను మార్చండి",
"ఫండ్ పాస్‌వర్డ్‌ను మార్చండి",
"సమర్పించు",
"కాష్‌ను ఖాళీ చేయండి",
"సైన్ అవుట్ చేయండి"
    ],
    label: [
"అసలు లాగిన్ పాస్‌వర్డ్",
"కొత్త లాగిన్ పాస్‌వర్డ్",
"పాస్‌వర్డ్‌లను నిర్ధారించడం",
"అసలు డబ్బు కోడ్",
"కొత్త డబ్బు కోడ్",
"పాస్‌వర్డ్‌ను నిర్ధారించండి"
    ],
    placeholder: [
"దయచేసి అసలు లాగిన్ పాస్‌వర్డ్‌ను నమోదు చేయండి",
"దయచేసి కొత్త లాగిన్ పాస్‌వర్డ్‌ను నమోదు చేయండి",
"దయచేసి లాగిన్ పాస్‌వర్డ్‌ను నిర్ధారించండి",
"దయచేసి అసలు ఫండ్ పాస్‌వర్డ్‌ను నమోదు చేయండి",
"దయచేసి కొత్త ఫండ్ పాస్‌వర్డ్‌ను నమోదు చేయండి",
"దయచేసి ఫండ్ పాస్‌వర్డ్‌ను నిర్ధారించండి"
    ]
  },
  userSet: {
    default: [
"నిజమైన పేరు ధృవీకరణ",
"వివరణాత్మక సమాచారం",
"బైండ్ అలిపే",
"సమర్పించు"
    ],
    label: [
"అసలు పేరు",
"QQ",
"అలిపే ఖాతా",
"అలిపే పేరు"
    ],
    placeholder: [
"దయచేసి నిజమైన పేరును నమోదు చేయండి (నా పేరు నగదు ఉపసంహరణకు ఉపయోగించబడుతుంది)",
"QQ నంబర్‌ను నమోదు చేయండి",
"దయచేసి అలిపే ఖాతాను నమోదు చేయండి",
"దయచేసి అలిపే పేరును నమోదు చేయండి"
    ],
    tips: "రిమైండర్: బౌండ్ చేసిన బ్యాంక్ కార్డ్‌ను సవరించలేరు, ఇది మీ ఉపసంహరణకు ఉపయోగించబడుతుంది."
  },
  bindAccount: {
    default: [
 "ఖాతాను బైండ్ చేయి",
"ట్యుటోరియల్ చూడండి",
"సమర్పించు"
    ],
    tabs: [
"ఖాతా",
"ఖాతా",
"ఖాతా"
    ],
    label: [
"సూచనలు",
"స్క్రీన్‌షాట్‌ను జోడించు",
"ఖాతా"
    ],
    placeholder: "దయచేసి మీ {account} ఖాతాను నమోదు చేయండి"
  },
  bankCard: {
    default: [
"బ్యాంక్ కార్డును బైండ్ చేయి",
"ఇప్పుడే ప్రామాణీకరించు",
"సమర్పిస్తోంది...",
"ఇప్పుడే జోడించు",
"బ్యాంక్ కార్డును జోడించు"
    ],
    tips: [
"దయచేసి బ్యాంక్ కార్డ్‌ను జోడించే ముందు నిజ-పేరు ప్రామాణీకరణను పూర్తి చేయండి",
"మీ బ్యాంక్ కార్డ్‌లోని ఖాతా పేరు మీరు ప్రామాణీకరించిన నిజ-పేరుకు అనుగుణంగా ఉండాలి, లేకుంటే మీరు విజయవంతంగా నగదును ఉపసంహరించుకోలేరు."
    ],
    label: [
"పేరు",
"బ్యాంక్ పేరు",
"బ్యాంక్ ఖాతా నంబర్",
"బ్రాంచ్ కోడ్",
"IFSC"
    ],
    placeholder: [
"దయచేసి బ్యాంక్ పేరును ఎంచుకోండి",
"దయచేసి బ్యాంక్ ఖాతా నంబర్‌ను నమోదు చేయండి",
"దయచేసి బ్రాంచ్ కోడ్‌ను నమోదు చేయండి",
"నిర్ధారించండి",
"రద్దు చేయి" ,
"దయచేసి IFSCని నమోదు చేయండి"
    ]
  },
  wallet: {
    default: [
"నా వాలెట్",
"రీఛార్జ్",
"ఉపసంహరణ",
"రీఛార్జ్ రికార్డ్",
"ఉపసంహరణ రికార్డ్",
"R",
"W",
"₽ రీఛార్జ్"
    ],
    label: [
"ఉపసంహరణ పద్ధతి",
"ఉపసంహరణ మొత్తం",
"నిధి పాస్‌వర్డ్",
"సమర్పించు",
"ఫోన్ నంబర్",
"ఇమెయిల్",
"IFSC",
"చెల్లింపు పద్ధతి",
"పన్ను",
"వాస్తవ మొత్తం అందుకుంది"
    ],
    placeholder: [
"ఉపసంహరణ పద్ధతిని ఎంచుకోండి",
"దయచేసి ఉపసంహరణ మొత్తాన్ని ఇన్‌పుట్ చేయండి",
"దయచేసి ఫండ్ పాస్‌వర్డ్‌ను ఇన్‌పుట్ చేయండి",
"దయచేసి ఉపసంహరణ పద్ధతిని ఎంచుకోండి",
"దయచేసి చెల్లింపుదారుడి మొబైల్ ఫోన్ నంబర్‌ను నమోదు చేయండి",
"దయచేసి చెల్లింపుదారుడి ఇమెయిల్ చిరునామాను నమోదు చేయండి",
"దయచేసి చెల్లింపుదారుడి IFSCని నమోదు చేయండి",
"దయచేసి చెల్లింపు పద్ధతిని ఎంచుకోండి"
    ],
    msg: [
"మీరు ఇంకా ఫండ్ పాస్‌వర్డ్‌ను సెట్ చేయలేదు, దయచేసి ముందుగా ఒకదాన్ని సెట్ చేయండి",
"మీరు ఇంకా మీ బ్యాంక్ కార్డును లింక్ చేయలేదు, దయచేసి ముందుగా దాన్ని లింక్ చేయండి",
"<p>ఉపసంహరణ సమయం:</p><p>సోమవారం: M9</p><p>మంగళవారం: M8</p><p>బుధవారం: M6/M7</p><p>గురువారం: M3/M4/M5</p><p>శుక్రవారం: M1/M2</p><p>(సోమవారం నుండి ఆదివారం వరకు ఇంటర్న్‌లు)</p><p>ఉదయం 9 నుండి సాయంత్రం 6 వరకు</p>"
    ]
  },
  recharge: {
    default: [
"రీఛార్జ్",
"రీఛార్జ్ వివరాలు",
"రీఛార్జ్ రికార్డ్",
"అందుబాటులో ఉన్న బ్యాలెన్స్ {money}, దయచేసి రీఛార్జ్ పద్ధతిని ఎంచుకోండి",
"కనీస సింగిల్ మొత్తం {currency} {min}, గరిష్టంగా {currency} {max}, హ్యాండ్లింగ్ ఫీజు {fee}%",
"సమర్పిస్తోంది...",
"ఇప్పుడే రీఛార్జ్ చేస్తోంది",
"తిరిగి పంపుతోంది",
"లోడ్ అవుతోంది...",
"కనీస సింగిల్ మొత్తం ${min}, గరిష్టంగా ${max}, హ్యాండ్లింగ్ ఫీజు {fee}%"
    ],
    label: [
"రీఛార్జ్ మొత్తం",
"రీఛార్జ్ ఛానెల్",
"బదిలీ పేరు",
"చెల్లింపుదారు పేరు",
"చెల్లింపుదారు మొబైల్ ఫోన్",
"చెల్లింపుదారు UPI ఖాతా",
"చెల్లింపుదారు ఇమెయిల్",
"లావాదేవీ ఆర్డర్"
    ],
    placeholder: [
"దయచేసి రీఛార్జ్ మొత్తాన్ని నమోదు చేయండి",
"దయచేసి రీఛార్జ్ ఛానెల్‌ని ఎంచుకోండి",
"దయచేసి బదిలీ పేరును నమోదు చేయండి",
"కనీస ఒకే మొత్తం {currency} {min}",
"గరిష్ట ఒకే మొత్తం {currency} {max}",
"దయచేసి చెల్లింపుదారు పేరును నమోదు చేయండి",
"దయచేసి చెల్లింపుదారు మొబైల్ ఫోన్ నంబర్‌ను నమోదు చేయండి",
"దయచేసి చెల్లింపుదారు యొక్క UPI ఖాతాను నమోదు చేయండి",
"దయచేసి చెల్లింపుదారు యొక్క ఇమెయిల్ చిరునామాను నమోదు చేయండి",
"దయచేసి బదిలీ యొక్క స్క్రీన్‌షాట్‌ను అప్‌లోడ్ చేయండి",
"దయచేసి లావాదేవీ ఆర్డర్ నంబర్‌ను నమోదు చేయండి"
    ],
    info: [
"రీఛార్జ్ మొత్తం",
"ఆర్డర్ నంబర్",
"బ్యాంక్",
"ఖాతా నంబర్",
"పేరు",
"కాపీ",
"{type} బదిలీ",
"బదిలీ స్క్రీన్‌షాట్",
"సమర్పించు",
"IFSC కోడ్",
"ఖాతా రకం",
"ప్రాసెసింగ్ సూచనలు"
    ],
    tips: [
"ఆర్థిక తనిఖీలో జాప్యాన్ని నివారించడానికి సరిపోలే మొత్తాన్ని బదిలీ చేయడానికి దయచేసి క్రింది పద్ధతిని ఎంచుకోండి.<br>బదిలీ తర్వాత, దయచేసి బదిలీ స్క్రీన్‌షాట్‌ను ధృవీకరణ ధృవీకరణ పత్రంగా అప్‌లోడ్ చేయండి",
"స్నేహితులను జోడించాల్సిన అవసరం లేదు, నాకు డబ్బు బదిలీ చేయడానికి QR కోడ్‌ను స్కాన్ చేయాల్సిన అవసరం లేదు",
"దయచేసి దిగువ సమాచారం ప్రకారం బదిలీని పూర్తి చేయండి",
"సూచన: విజయవంతమైన చెల్లింపు తర్వాత, మీ సభ్యుని ఖాతా నంబర్, రీఛార్జ్ మొత్తం, ఆర్డర్ నంబర్, డిపాజిటర్ ఖాతా నంబర్, రీఛార్జ్ సమయం, మీ కోసం నిధులను సకాలంలో జోడించడానికి ఆర్థిక శాఖకు అనుకూలమైనది అందించడానికి ఆన్‌లైన్ సేవను సంప్రదించండి.",
"గమనిక: దయచేసి ప్రతి బదిలీకి ఒక చెల్లింపును సమర్పించండి",
"బదిలీ తర్వాత, దయచేసి బదిలీ స్క్రీన్‌షాట్‌ను ధృవీకరణ ధృవీకరణ పత్రంగా అప్‌లోడ్ చేయండి",
"చిట్కా: చెల్లింపు విజయవంతమైన తర్వాత, దయచేసి విజయవంతమైన లావాదేవీ యొక్క చిత్రాన్ని అప్‌లోడ్ చేయండి",
"<p>రీఛార్జ్ రిమైండర్: దయచేసి రీఛార్జ్ చేయడానికి ముందు చదవండి.</p><p>1: దయచేసి తాజా రీఛార్జ్ ఖాతా ప్రకారం చెల్లించండి.</p><p>2: చెల్లింపు చెల్లుబాటు వ్యవధి 10 నిమిషాలు. దయచేసి 10 నిమిషాల్లో చెల్లింపును పూర్తి చేయండి. 10 నిమిషాల తర్వాత చెల్లింపు చేయకపోతే, స్వీకరించే ఖాతా చెల్లదు. చెల్లింపు కోసం దయచేసి తాజా రీఛార్జ్ ఖాతాను తిరిగి పొందండి.</p><p>3: బదిలీ మొత్తం మీరు సమర్పించిన మొత్తానికి అనుగుణంగా ఉండాలి.</p><p>4: చెల్లింపు విఫలమైతే, దయచేసి మునుపటి స్వీకరించే ఖాతాను సేవ్ చేయవద్దు. తాజా ఖాతాను పొందడానికి దయచేసి రీఛార్జ్ ఆర్డర్‌ను తిరిగి సమర్పించండి, లేకుంటే మీ చెల్లింపు చెల్లదు.</p><p>5: చెల్లింపు విజయవంతమైతే, ఆర్థిక శాఖ ద్వారా సకాలంలో ధృవీకరణను సులభతరం చేయడానికి అవసరమైన విధంగా UTRను సమర్పించండి.</p>"
    ],
    minPayHint: "కనీస చెల్లింపు మొత్తం {min}TJS"
  },
  postTask:[
"శీర్షిక",
"చిత్రాన్ని ఎంచుకోండి",
"బట్వాడా చేయి",
"దయచేసి పనికి శీర్షికను నమోదు చేయండి"
  ],
  task: {
    default: [
"డెలివరీ జాబితా",
"పని అవసరాలు",
"సృష్టించు",
"ఆడిట్",
"లింక్‌ను తెరవండి",
"లింక్‌ను కాపీ చేయండి",
"యూనిట్ ధర",
"సమర్పించు",
"మినహాయింపు",
"సర్వీస్ చేయడం ప్రారంభించండి",
"ప్రోగ్రెస్‌లో ఉంది",
"డిప్లాయ్‌మెంట్ ప్రారంభించండి"
    ],
    tabs: [
"చేస్తున్నాను",
"ఆడిట్",
"పూర్తయింది",
"విఫలమైంది",
"దుర్మార్గం",
"వదిలివేయబడింది"
    ],
    msg: "నేటి లక్ష్యం పూర్తయింది.",
    msgSc: "విజయవంతంగా అందుకుంది",
    msgTime: "కౌంట్‌డౌన్ ముగిసిన తర్వాత, పని స్వయంచాలకంగా పూర్తవుతుంది మరియు దానిని ముందుగానే మూసివేయడం చెల్లదు.!",
    info: [
"టాస్క్ వివరాలు",
"టాస్క్ శీర్షిక",
"టాస్క్ ప్రయోజనాలు",
"టాస్క్ వివరణ",
"అప్‌లోడ్ అవసరాలు",
"నమూనాను సమర్పించు",
"వినియోగదారు నమూనాను సమర్పించలేదు",
"ఆడిట్ గమనికలు",
"ఆడిట్ తేదీ",
"డిమాండ్ వైపు",
"విడుదల",
"కాపీ",
"జంప్",
"టాస్క్ దశలు",
"దశ {సూచిక}",
"ఆడిట్ నమూనా",
"ఆడిట్ నమూనా లేదు",
"డేటా లోడింగ్...",
"పనిని వదులుకోండి",
"పూర్తయిన పనిని సమర్పించు",
"కంటెంట్‌ను ప్రచురించు"
    ],
    index: [
"ప్రస్తుత స్థితి",
"మీ ప్రస్తుత రేటింగ్ <i style=\"color:#1989fa\">{currVip}</i><br>ప్రస్తుత <i style=\"color:#1989fa\">{currVip}</i><br>మీరు <i style=\"color:#dd6161\">{vip}</i> స్థాయిలో చేరాలనుకుంటున్నారా అనే <i style=\"color:#dd6161\">{currVip}</i> స్థాయిలో మాత్రమే ప్రస్తుత <i style=\"color:#1989fa\">{currVip}</i> స్థాయి టాస్క్‌ను మాత్రమే క్లెయిమ్ చేయగలదు",
"ఇప్పుడే చేరండి",
"దయచేసి టాస్క్ వర్గాన్ని ఎంచుకోండి",
"రద్దు చేయి",
      "మిగిలినది",
      "ఉచిత డెలివరీ",
      "త్వరలో వస్తుంది"
    ],
    list: [
"పని జాబితా",
"డిమాండ్ వైపు",
"మిగిలినది",
"అభ్యర్థన",
"స్వీకరిస్తోంది"
    ],
    show: [
"పని వివరాలు",
"కొనుగోలు సమయం",
"డెలివరీ స్థితి",
"అద్దె ధర",
"డెలివరీ సమయం",
"స్వీకరించడానికి కౌంట్‌డౌన్",
"సర్వీస్ చేయడం ప్రారంభించండి",
"కోడింగ్",
"తెలియదు"
    ]
  },
  postRecord: [
"రోజువారీ నవీకరణలు",
"విడుదల",
"మొత్తం",
"పూర్తయింది",
"గడువు తేదీ",
"ఆడిట్",
"రద్దు",
"సంపాదకులు",
"రోజువారీ నవీకరణలు",
"స్వీకరించబడింది",
"SGM.s ప్రకటనల కేంద్రం",
"సమాచార కేంద్రం"
  ],
  dayReport: [
"రోజువారీ స్టేట్‌మెంట్",
"మొత్తం ఆదాయం",
"నా కమిషన్",
"నా కమిషన్ ప్రయోజనాలు",
"సబార్డినేట్‌ల ద్వారా డెలివరీ పూర్తి చేయబడింది",
"సబార్డినేట్ టాస్క్ ప్రయోజనాలు",
"PCE",
"గత 30 రోజులు",
"పరిమాణం",
"డెలివరీ",
"సబార్డినేట్",
"వినియోగం",
"తేదీ"
  ],
  fundRecord: {
    default: [
"వ్యయ రికార్డులు",
"రీఛార్జ్ రికార్డు",
"ఆదాయ రికార్డులు",
"R",
"I",
"E",
"ఉపసంహరణ రికార్డులు",
    ],
    tabs: [
"ఆదాయం",
"ఖర్చు",
"రీఛార్జ్",
"ఉపసంహరణ"
    ],
	state: [
		'అన్నీ',
		'రీఛార్జ్',	//1 recharge
		'ఉపసంహరణ',	//2 withdrawal
		'టాస్క్‌ను పోస్ట్ చేయండి',	//3 task
		'ప్లాట్ పంప్',	//4 pump
		'రాయితీ',	//5 rebate
		'డెలివరీ పూర్తయింది',	//6 commission
		'యాక్టివిటీ రివార్డ్‌లు',	//7 regment
		'సిఫార్సు బహుమతులు',	//8 spread
		'అప్‌గ్రేడ్ చేయండి',	//9 buymembers
		'టాస్క్‌ను రద్దు చేయి',	//10 revoke
		'పెట్టుబడి ఆదాయం',	//11 transfer_c
		'పెట్టుబడికి బదిలీ',	//12 transfer_r
		'ఇతర ఆదాయం', //13 其他
		'దానం చేయండి',	//14
		'ఎరుపు రంగు ఎన్వలప్',	//15
		'స్మార్ట్ రోబోట్‌లను కొనండి',//16
		'లక్కీ పెడల్',//17
		'VIP కొనుగోలు వాపసు',//18
	]
  },
  promote: [
"మీ ప్రాణ స్నేహితుడు",
"{title}లో చేరమని మిమ్మల్ని ఆహ్వానించండి",
"రిఫరల్ కోడ్",
"సిఫార్సు కోడ్‌ను కాపీ చేయండి",
"ఆహ్వాన లింక్‌ను కాపీ చేయండి",
"QR కోడ్‌ను సేవ్ చేయండి",
"ప్రచార ప్రోత్సాహకాలు",
"పోస్టర్‌ను విజయవంతంగా సేవ్ చేయండి",//7
"పోస్టర్‌ను సేవ్ చేయడంలో విఫలమైంది, దయచేసి మరికొన్ని సార్లు ప్రయత్నించండి లేదా స్క్రీన్‌షాట్‌ను సేవ్ చేయండి",
"దయచేసి స్క్రీన్‌షాట్ తీసుకోండి",
"ప్రమోషన్ పోస్టర్‌ను సేవ్ చేయండి",
"ప్రమోషన్ పోస్టర్‌ను మీ ఫోన్‌లో సేవ్ చేయండి<br>మీరు విఫలమైతే, దయచేసి మరికొన్ని సార్లు ప్రయత్నించండి లేదా స్క్రీన్‌షాట్‌ను సేవ్ చేయండి",
"SGM VIP అధికారిక వినియోగదారులు మాత్రమే స్నేహితులను చేరమని ఆహ్వానించడానికి అర్హులు!",
"షేర్డ్ ఇన్విటేషన్",
'<p>1.  షేరింగ్ బోనస్: SGMలో కొత్త వినియోగదారులను ఆహ్వానించినప్పుడు, మీరు షేరింగ్ బోనస్‌ను పొందవచ్చు.</p><p>2.  టీమ్ కమీషన్: మీ క్రింద ఉన్నవారి సైక్లింగ్ కార్యకలాపాల నుండి మీరు ప్రతిరోజూ కమీషన్ పొందవచ్చు.</p><p><3.  కంపెనీ కార్యకలాపాలు: కంపెనీ క్రమం తప్పకుండా వివిధ ప్రచార కార్యకలాపాలను ప్రారంభిస్తుంది, వీటిలో “Lucky pedal”, “Cycling Code” మరియు భౌతిక బహుమతులు ఉంటాయి./p><p>4.  సంచిత బహుమతులు: నిర్దిష్ట సంఖ్యలో స్నేహితులను ఆహ్వానించిన తర్వాత, మీరు ప్లాట్‌ఫారమ్ హోమ్‌పేజీలో నిర్దిష్ట నగదు బహుమతులను పొందవచ్చు. మీరు ఎంత ఎక్కువ మందిని ఆహ్వానిస్తే, బహుమతి అంత ఎక్కువగా ఉంటుంది.</p><p>5.  కంపెనీ పదవులు: మీ బృందం నిర్దిష్ట స్థాయికి చేరుకున్న తర్వాత, మీరు కంపెనీలో జూనియర్, మిడ్‌లెవల్, సీనియర్ మరియు మార్కెటింగ్ మేనేజర్ వంటి మరిన్ని పదవుల కోసం దరఖాస్తు చేసుకోవచ్చు మరియు అదనపు నెలవారీ జీతం పొందవచ్చు.</p><p>మోహరించిన ప్రతి సైకిల్ ఆర్థిక స్వాతంత్ర్యం వైపు ఒక అడుగు; ప్రతి రైడ్ నగర ఉద్గారాలను తగ్గిస్తుంది. SGM మీకు ఆర్థిక స్వాతంత్ర్యం మరియు పర్యావరణ అనుకూల జీవనం యొక్క ద్వంద్వ లక్ష్యాలను సాధించడంలో సహాయపడుతుంది.</p>'
,"టీమ్ షేరింగ్ ట్రావెల్"
  ],
  teamReport: {
    default: [
"శోధన",
"జట్టు బ్యాలెన్స్",
"జట్టు ప్రయోజనాలు",
"జట్టు రీఛార్జ్",
"జట్టు ఉపసంహరణ",
"మొదటి ఛార్జ్ సంఖ్య",
"మొదటి పుష్ సంఖ్య",
"జట్టు పరిమాణం",
"కొత్త జట్టు",
"PCE",
"నేను",
"యూజర్",
"రీఛార్జ్",
"ఉపసంహరణలు",
"రిబేట్",
"కమీషన్",
"తేదీని ఎంచుకోండి",
"డేటా లేదు",
"ఉపసంహరణల మొత్తం",
"ఉపసంహరణల సంఖ్య",
"ఉపసంహరణల రిబేట్",
"జట్టు ఉపసంహరణల సంఖ్య",//21
"జట్టు భాగస్వామి",
"సిఫార్సు చేయబడిన మొత్తం ఆదాయం",
"డెలివరీ రాయితీల నుండి మొత్తం ఆదాయం",
"స్థాయి 3 జట్టు మొత్తం ఉపసంహరణలు",
"గ్రేడ్",
"తల్లిదండ్రులు",
"ఆహ్వానించబడినవారు",
"వినియోగదారు జాబితా",
"మొత్తం వినియోగదారు"
    ],
    tabs: [
 "జట్టు నివేదికలు",
"నా బృందం"
    ],
    team: [
"స్థాయి 1",
"స్థాయి 2",
"స్థాయి 3"
    ]
  },
  help: [
"సహాయ మాన్యువల్",
"అందుబాటులో లేదు"
  ],
  message:[
"సందేశాన్ని వీక్షించండి",
"సందేశం లేదు"
  ],
  credit: [
"క్రెడిట్ స్కోర్",
"క్రెడిట్ నోట్",
"క్రెడిట్ రికార్డులు",
"<p>ప్రారంభ క్రెడిట్ స్కోర్ 60 పాయింట్లు.</p><p>1: పాయింట్లు 50 కంటే తక్కువ ఉంటే, రోజువారీ డెలివరీ పరిమాణం సగానికి తగ్గించబడుతుంది.</p><p>2: స్కోరు 30 పాయింట్ల కంటే తక్కువ ఉంటే మరియు రోజువారీ డెలివరీ పనిని పూర్తి చేయడం సాధ్యం కాదు.</p><p>3: స్కోరు 10 పాయింట్ల కంటే తక్కువ ఉంటే, మీరు నగదు ఉపసంహరణకు దరఖాస్తు చేసుకోలేరు.</p><p>పాయింట్ రివార్డ్ నియమాలు: పని స్థాయిని అప్‌గ్రేడ్ చేయడం వల్ల 5 పాయింట్లు జోడించబడతాయి మరియు సబార్డినేట్‌లను (అధికారిక ఉద్యోగులు)గా ఆహ్వానించడం వల్ల 1 పాయింట్ జోడించబడుతుంది.</p><p>ప్రతికూల పని వైఖరి, సమయానికి డెలివరీ పూర్తి చేయడంలో వైఫల్యం మరియు కంపెనీ నిబంధనల ఉల్లంఘన ఒకరి క్రెడిట్ స్కోర్‌ను ప్రభావితం చేస్తుంది.</p>",
"నా క్రెడిట్",
"ప్రస్తుతానికి క్రెడిట్ రికార్డ్ లేదు"
  ],
  dialog: [
"చిట్కాలు",
"నిర్ధారించండి",
"సమర్పిస్తోంది...",
"కాపీ విజయవంతమైంది",
"IOS సిస్టమ్ వెర్షన్ తక్కువగా ఉంది మరియు మద్దతు లేదు",
"నమోదు చేస్తోంది...",
"డేటా లోడ్ అవుతోంది..."
  ],
  lineList: [
"లైన్ ఎంపిక",
"కరెంట్ లైన్",
"లైన్"
  ],
  serviceCenter: [
"కస్టమర్ సర్వీస్",
"హాయ్, ప్రత్యేకమైన కస్టమర్ సర్వీస్",
"మీకు సేవ చేయడం ఆనందంగా ఉంది.",
"స్వీయ సేవ",
"ఆన్‌లైన్ కస్టమర్ సర్వీస్",
"రీఛార్జ్ కస్టమర్ సర్వీస్",
"లైన్ కస్టమర్ సర్వీస్"
  ],
  direct:[
'SGM.s',
'వృద్ధి బోనస్',
'కార్యాచరణ వివరణ',
'<p>VIP స్థాయిలో చేరడానికి సభ్యులను నేరుగా ఆహ్వానించిన తర్వాత, మీరు షరతులకు అనుగుణంగా ఉంటే మీరు నగదు బహుమతులు పొందవచ్చు!</p><p>ఉదాహరణకు: మీరు 3 VIP-స్థాయి సభ్యులను సమిష్టిగా ఆహ్వానిస్తే, మీరు నేరుగా బహుమతిని పొందవచ్చు. దానిని స్వీకరించిన తర్వాత, ఇతర లక్ష్యాలను సాధించడం కొనసాగించండి మరియు దానిని స్వీకరించడం కొనసాగించండి.</p><p>SGM ప్రత్యేక వృద్ధి బహుమతి, ప్రతి ఉద్యోగి ప్రతి అవార్డును ఒకసారి మాత్రమే స్వీకరించగలరు.</p>',
'సబార్డినేట్‌ల సంఖ్య',
'పూర్తి చేయాలి',
'ఆహ్వాన ప్రయోజనాలు',
'రివార్డులను స్వీకరించండి',
'అందుకున్నవి'
  ],
  activity:[
'డీడ్స్ పెడల్',
'వివరాలు',
'విరాళం',
'ఖాతా బ్యాలెన్స్',
'అన్నీ',
'చెల్లించు',
'దయచేసి విరాళం మొత్తాన్ని నమోదు చేయండి',
'మీ విరాళానికి ధన్యవాదాలు'
  ],
  apply: {
    awardsTitle: "Awards",
    awardsContent: "Awards",
    pickUpVehicles: "{count} వాహనాలను తీసుకోండి"
  },
  positions:{
    info:['పొజిషన్ వివరాలు', 'పొజిషన్ అప్లికేషన్', 'పోజిషన్', 'లెవల్ 3 టీమ్ జి-లెవల్ రెగ్యులర్ ఉద్యోగులు', 'థర్డ్-లెవల్ టీమ్ సభ్యుల నిష్పత్తి', 'ఈ నెల జీతం', 'జీతం సెటిల్మెంట్', 'పూర్తయింది', 'పూర్తవుతుంది', 'అందుకున్నది', 'జీతం వసూలు సమయం'],
    job: [
		'సమీక్ష కోసం సమర్పించండి',
		'సమీక్షలో ఉంది','సమీక్షించబడింది',
		'దయచేసి మీ సంబంధిత పత్రాలను అప్‌లోడ్ చేయండి',
		'వ్యాఖ్యలు',
		'మీ ID ఫోటోను ఎంచుకోవడానికి మరియు అప్‌లోడ్ చేయడానికి చిత్రంపై క్లిక్ చేయండి. ',
		'దయచేసి ఫోటో Aలో మీ ID కార్డ్ ముందు భాగం యొక్క ఫోటోను అప్‌లోడ్ చేయండి. ',
		'దయచేసి ఫోటో Bలో మీ ID కార్డ్ వెనుక భాగం యొక్క ఫోటోను అప్‌లోడ్ చేయండి. ',
		'దయచేసి ఫోటో Cలో మీ ID కార్డ్‌ను పట్టుకున్న మీ ఫోటోను అప్‌లోడ్ చేయండి. ',
		'ఫోటో A',
		'ఫోటో B',
		'ఫోటో C',
		'దయచేసి మీరు పదోన్నతి పొందాలనుకుంటున్న స్థానాన్ని ఎంచుకోండి',
		'స్థానం',
		'ప్రాథమిక జీతం',
		'అదనపు బోనస్',
		'ఉద్యోగులకు నోటీసు',
		'నేను 《పోజిషన్ అప్లికేషన్ మార్గదర్శకాలు》 లోని విషయాలను చదివి అంగీకరించాను.',
		'స్థానం దరఖాస్తును సమర్పించండి',
		'దయచేసి ఒక స్థానాన్ని ఎంచుకోండి',
		'దయచేసి ఫోటో Aని ఎంచుకోండి',
		'దయచేసి ఫోటో Bని ఎంచుకోండి',
		'దయచేసి ఫోటో Cని ఎంచుకోండి']
  },
}